const sliceAdd = (window.location.href.includes('localhost') ? 12 : 100)

export {sliceAdd}
